// src/pages/Vouchers/GeneralPaymentForm.jsx
import React from 'react';
import VoucherForm, { VOUCHER_CONFIGS } from './VoucherForm';

export default function GeneralPaymentForm() {
  return <VoucherForm config={VOUCHER_CONFIGS.generalPayment} />;
}
